import { useCallback, useState } from 'react';

let counter = 0;

// Returns function that forces component re-render. Should be used only in rare optimisation cases,
// like manual optimising too frequent mobx `observer` re-renders.
export function useForceUpdate() {
  const [, setState] = useState(0);
  return useCallback(() => setState(++counter), []);
}
